var React = require('react');

function ShardBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0V675H1800V316.232L1308.51 523.86L0 0Z","fill":"#2B40C7"}));
}

ShardBottom.defaultProps = {"viewBox":"0 0 1800 675","fill":"none"};

module.exports = ShardBottom;

ShardBottom.default = ShardBottom;
